import React, {Component} from 'react'

export default class NagrodyTekst extends Component {

    render() {
        return <div class="text-center nagrody" style={{margin: 25}}>
            <div className="row">
                <div className='col-sm-4'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/lg.jpg'><img width="253" height="300"
                                                                          src="/files/marcel-image/nagrody/lg.jpg"
                                                                          className="attachment-medium"
                                                                          alt="lg"/></a>
                    </dt>
                </div>
                <div className='col-sm-4'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/ndp.jpg'><img width="192" height="300"
                                                                           src="/files/marcel-image/nagrody/ndp.jpg"
                                                                           className="attachment-medium"
                                                                           alt="ndp"/></a>
                    </dt>
                </div>
                <div className='col-sm-4'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/ng.jpg'><img width="213" height="300"
                                                                          src="/files/marcel-image/nagrody/ng.jpg"
                                                                          className="attachment-medium"
                                                                          alt="ng"/></a>
                    </dt>
                </div>
                <br/>
            </div>
            <p>&nbsp;</p>
            <div className='row'>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/a7e8d32836f3b73e3f617234f61b12720609aabe.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/a7e8d32836f3b73e3f617234f61b12720609aabe.jpg"
                            className="attachment-thumbnail" alt="a7e8d32836f3b73e3f617234f61b12720609aabe"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/0b3e0f8fac5ce40e43d0a1442ed58f0a7e9b9297.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/0b3e0f8fac5ce40e43d0a1442ed58f0a7e9b9297.jpg"
                            className="attachment-thumbnail" alt="0b3e0f8fac5ce40e43d0a1442ed58f0a7e9b9297"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/abb5b1792a51b1262e3ffcdcbfd1d3f52885ca02.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/abb5b1792a51b1262e3ffcdcbfd1d3f52885ca02.jpg"
                            className="attachment-thumbnail" alt="abb5b1792a51b1262e3ffcdcbfd1d3f52885ca02"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon landscape'>
                        <a href='/files/marcel-image/nagrody/44ede8aca3c57e48012b41d0f23f3b57193ec607.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/44ede8aca3c57e48012b41d0f23f3b57193ec607.jpg"
                            className="attachment-thumbnail" alt="44ede8aca3c57e48012b41d0f23f3b57193ec607"/></a>
                    </dt>
                </div>
                <br/>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/d0f4840deaab10b0c0d1a7ad73555e26702e6c18.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/d0f4840deaab10b0c0d1a7ad73555e26702e6c18.jpg"
                            className="attachment-thumbnail" alt="d0f4840deaab10b0c0d1a7ad73555e26702e6c18"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/141af271cd53a29789648f8e8a1e7c827b68d891.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/141af271cd53a29789648f8e8a1e7c827b68d891.jpg"
                            className="attachment-thumbnail" alt="141af271cd53a29789648f8e8a1e7c827b68d891"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/b33041a97422d73c4ae1a43c6cb3b91ddb8afb1c.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/b33041a97422d73c4ae1a43c6cb3b91ddb8afb1c.jpg"
                            className="attachment-thumbnail" alt="b33041a97422d73c4ae1a43c6cb3b91ddb8afb1c"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon landscape'>
                        <a href='/files/marcel-image/nagrody/edb756fb3144a7462bea42555d2a9c17efe5f42e.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/edb756fb3144a7462bea42555d2a9c17efe5f42e.jpg"
                            className="attachment-thumbnail" alt="edb756fb3144a7462bea42555d2a9c17efe5f42e"/></a>
                    </dt>
                </div>
                <br/>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/2c3aad6d8d2271553226954c12f2f6d9b3521df6.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/2c3aad6d8d2271553226954c12f2f6d9b3521df6.jpg"
                            className="attachment-thumbnail" alt="2c3aad6d8d2271553226954c12f2f6d9b3521df6"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/fa762379e7f3103d60139a36c538f470297131ad.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/fa762379e7f3103d60139a36c538f470297131ad.jpg"
                            className="attachment-thumbnail" alt="fa762379e7f3103d60139a36c538f470297131ad"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/d43b2439dd8cf80992d3d865a7d9c5ab6e122e2f.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/d43b2439dd8cf80992d3d865a7d9c5ab6e122e2f.jpg"
                            className="attachment-thumbnail" alt="d43b2439dd8cf80992d3d865a7d9c5ab6e122e2f"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon landscape'>
                        <a href='/files/marcel-image/nagrody/87fc3c72533fe522683ae151c5688f5b37d1129f.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/87fc3c72533fe522683ae151c5688f5b37d1129f.jpg"
                            className="attachment-thumbnail" alt="87fc3c72533fe522683ae151c5688f5b37d1129f"/></a>
                    </dt>
                </div>
                <br/>
                <div className='col-sm-3'>
                    <dt className='gallery-icon landscape'>
                        <a href='/files/marcel-image/nagrody/ca3d76f4e8d81f8bd1dadea18114795af13fae6a.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/ca3d76f4e8d81f8bd1dadea18114795af13fae6a.jpg"
                            className="attachment-thumbnail" alt="ca3d76f4e8d81f8bd1dadea18114795af13fae6a"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/bbe32f06055699c21dad290d7eecdfa2bf4e8978.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/bbe32f06055699c21dad290d7eecdfa2bf4e8978.jpg"
                            className="attachment-thumbnail" alt="bbe32f06055699c21dad290d7eecdfa2bf4e8978"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/6a87260863920d94f68606831e03d7af2891a787.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/6a87260863920d94f68606831e03d7af2891a787.jpg"
                            className="attachment-thumbnail" alt="6a87260863920d94f68606831e03d7af2891a787"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/fd495d6b2abb359f42235971cb8cec7fe5b70c0f.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/fd495d6b2abb359f42235971cb8cec7fe5b70c0f.jpg"
                            className="attachment-thumbnail" alt="fd495d6b2abb359f42235971cb8cec7fe5b70c0f"/></a>
                    </dt>
                </div>
                <br/>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/4980ff5e9a3149d54f4a3070ffeb3d6438388936.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/4980ff5e9a3149d54f4a3070ffeb3d6438388936.jpg"
                            className="attachment-thumbnail" alt="4980ff5e9a3149d54f4a3070ffeb3d6438388936"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/31ae5d7ea696e8c314885a0e9dc2b1e31ca91dc4.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/31ae5d7ea696e8c314885a0e9dc2b1e31ca91dc4.jpg"
                            className="attachment-thumbnail" alt="31ae5d7ea696e8c314885a0e9dc2b1e31ca91dc4"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/fb02fa280eba9546d654d20bbfcb9b653acefd29.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/fb02fa280eba9546d654d20bbfcb9b653acefd29.jpg"
                            className="attachment-thumbnail" alt="fb02fa280eba9546d654d20bbfcb9b653acefd29"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/38a7f1f5629f782af27de03af6e853e9188aa286.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/38a7f1f5629f782af27de03af6e853e9188aa286.jpg"
                            className="attachment-thumbnail" alt="38a7f1f5629f782af27de03af6e853e9188aa286"/></a>
                    </dt>
                </div>
                <br/>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/b146400ba39a832c69e2f97a503f7b7cc0f9be94.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/b146400ba39a832c69e2f97a503f7b7cc0f9be94.jpg"
                            className="attachment-thumbnail" alt="b146400ba39a832c69e2f97a503f7b7cc0f9be94"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/2dafc141364082ef3eced274999b7dcf16e2204e.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/2dafc141364082ef3eced274999b7dcf16e2204e.jpg"
                            className="attachment-thumbnail" alt="2dafc141364082ef3eced274999b7dcf16e2204e"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/95ec95c894ac68d318d891f54947e6e8480eae32.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/95ec95c894ac68d318d891f54947e6e8480eae32.jpg"
                            className="attachment-thumbnail" alt="95ec95c894ac68d318d891f54947e6e8480eae32"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/w001.jpg'><img width="150"
                                                                            height="150"
                                                                            src="/files/marcel-image/nagrody/w001.jpg"
                                                                            className="attachment-thumbnail"
                                                                            alt="w001"/></a>
                    </dt>
                </div>
                <br/>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/5510052aa57d5f2394b1412f0d5bdfe301864606.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/5510052aa57d5f2394b1412f0d5bdfe301864606.jpg"
                            className="attachment-thumbnail" alt="5510052aa57d5f2394b1412f0d5bdfe301864606"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/2628a35dcb9900d1afb546352be121ccbb98956f.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/2628a35dcb9900d1afb546352be121ccbb98956f.jpg"
                            className="attachment-thumbnail" alt="2628a35dcb9900d1afb546352be121ccbb98956f"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/9395cd979f5d6631285b967e1011b3a747de55cf.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/9395cd979f5d6631285b967e1011b3a747de55cf.jpg"
                            className="attachment-thumbnail" alt="9395cd979f5d6631285b967e1011b3a747de55cf"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/55d91b899ffbdd61414006c00e9dddde68b13f8b.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/55d91b899ffbdd61414006c00e9dddde68b13f8b.jpg"
                            className="attachment-thumbnail" alt="55d91b899ffbdd61414006c00e9dddde68b13f8b"/></a>
                    </dt>
                </div>
                <br/>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/2ca1438f8d0472c11ce79608ffca0da82070d824.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/2ca1438f8d0472c11ce79608ffca0da82070d824.jpg"
                            className="attachment-thumbnail" alt="2ca1438f8d0472c11ce79608ffca0da82070d824"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/c1294e9362ea320d3a718bfdd3b3e2be1e1873a3.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/c1294e9362ea320d3a718bfdd3b3e2be1e1873a3.jpg"
                            className="attachment-thumbnail" alt="c1294e9362ea320d3a718bfdd3b3e2be1e1873a3"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/14fa9314a875fe926d6249d634bbd48915f06357.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/14fa9314a875fe926d6249d634bbd48915f06357.jpg"
                            className="attachment-thumbnail" alt="14fa9314a875fe926d6249d634bbd48915f06357"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon landscape'>
                        <a href='/files/marcel-image/nagrody/f11366a6454a4da08540822bec98a167e784f422.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/f11366a6454a4da08540822bec98a167e784f422.jpg"
                            className="attachment-thumbnail" alt="f11366a6454a4da08540822bec98a167e784f422"/></a>
                    </dt>
                </div>
                <br/>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/69ac73c090d0a982d2cadd8f951734acb4fe1935.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/69ac73c090d0a982d2cadd8f951734acb4fe1935.jpg"
                            className="attachment-thumbnail" alt="69ac73c090d0a982d2cadd8f951734acb4fe1935"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/bc4f636a143c4fb4ca01dfb06f12320f7348b167.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/bc4f636a143c4fb4ca01dfb06f12320f7348b167.jpg"
                            className="attachment-thumbnail" alt="bc4f636a143c4fb4ca01dfb06f12320f7348b167"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon portrait'>
                        <a href='/files/marcel-image/nagrody/9c15b9a41052585fdaaf9b91391c315dc83f52c0.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/9c15b9a41052585fdaaf9b91391c315dc83f52c0.jpg"
                            className="attachment-thumbnail" alt="9c15b9a41052585fdaaf9b91391c315dc83f52c0"/></a>
                    </dt>
                </div>
                <div className='col-sm-3'>
                    <dt className='gallery-icon landscape'>
                        <a href='/files/marcel-image/nagrody/7a856803b2d49a2581210044ac6ea0558b425f65.jpg'><img
                            width="150" height="150"
                            src="/files/marcel-image/nagrody/7a856803b2d49a2581210044ac6ea0558b425f65.jpg"
                            className="attachment-thumbnail" alt="7a856803b2d49a2581210044ac6ea0558b425f65"/></a>
                    </dt>
                </div>
                <br/>
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/firmaComponents/NagrodyTekst.js